<template>
    <form @submit="persistSection">
        <fieldset class="form-group">
            <legend>Infos animateur</legend>
            <label class="sr-only" for="infosAnim">Résumé</label>
            <textarea id="infosAnim" class="form-control" v-model="sectionDatas.infosAnimateur.datas"></textarea>
        </fieldset>

        <fieldset class="form-group">
            <legend>Infos réalisateur</legend>
            <label class="sr-only" for="infosReal">Résumé</label>
            <textarea id="infosReal" class="form-control" v-model="sectionDatas.infosRealisateur.datas"></textarea>
        </fieldset>

        <fieldset class="form-group">
            <legend>Titre(s) à passer</legend>
            <label class="sr-only" for="titreAPasser">Résumé</label>
            <textarea id="titreAPasser" class="form-control" v-model="sectionDatas.titreAPasser.datas"></textarea>
        </fieldset>

        <button type="submit" class="btn btn-primary" v-bind:disabled="editPending">Valider cette étape</button>
    </form>
</template>

<script>

  export default {

    name: 'DiffusionForm',

    props: {
      subject: Object,
      editPending: false
    },

    data() {
      return {
        sectionName: 'diffusion',
        sectionDatas: {
          infosRealisateur: {
            name: 'infos realisateur',
            datas: ''
          },
          infosAnimateur: {
            name: 'infos animateur',
            datas: ''
          },
          titreAPasser: {
            name: 'titre à passer',
            datas: ''
          }
        }
      }
    },

    mounted() {
      this.sectionDatas.infosRealisateur.datas = this.subject.infosRealisateur
      this.sectionDatas.infosAnimateur.datas = this.subject.infosAnimateur
      this.sectionDatas.titreAPasser.datas = this.subject.titreAPasser
      this.$emit('push-section', this.sectionDatas, this.sectionName)
    },

    methods: {
      persistSection: function (e) {
        e.preventDefault()
        this.$emit('push-edit', this.sectionDatas, this.sectionName)
      }
    }

  }

</script>


// WEBPACK FOOTER //
// src/components/EditSub/DiffusionForm.vue